import moment from "moment";

/**
 *
 * @param {Date} date date to adjust to the time offset
 * @param {number} timeOffset time offset in minutes
 * @returns a date adjusted to the new time offset
 */
export const adjustDateByOffset = (date, timeOffset) => {
  /**
   * using moment.js because node 16 doesn't support time offsets for the
   * time zone parameter, only IANA DB Time Zones
   * The following commented code is the same functionality but using
   * the Intl API instead of moment.js. This is left here to help with
   * migration if momentjs is removed in the future for being deprecated
   * const isoOffset = getIsoOffset(timeOffset);
   * const dateFormatter = new Intl.DateTimeFormat('en-US', { timeZone: isoOffset});
   * const adjustedDate = new Date(dateFormatter.format(date));
   *
   * return adjustedDate;
   */
  const adjustedDate = moment(date).utcOffset(timeOffset);

  return new Date(
    adjustedDate.year(),
    adjustedDate.month(),
    adjustedDate.date()
  );
};
